module.exports = __webpack_public_path__ + "img/circle-dollar.46441995.svg";